
import { queryPosts } from '@/graphql/wordpress/query/posts.js'

export default {
  name: 'LoadMorePosts',
  props: {
    pageInfo: {
      type: Object,
      required: true,
    },
    categoriesIds: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    async loadMore(endCursor) {
      try {
        this.$nuxt.$loading.start()
        // Ritorno i posts filtrano quelli già presenti nelle categorie sopra
        const requestNewPosts = await this.$apollo
          .query({
            query: queryPosts,
            variables: {
              first: 5,
              endCursor,
              categoryNotIn: this.categoriesIds.map(
                ({ categoryId }) => categoryId
              ),
            },
          })
          .then(({ data }) => data)
        this.$emit('loaded', requestNewPosts)
        this.$nuxt.$loading.finish()
      } catch (e) {
        console.error(e)
        return this.$nuxt.error({ statusCode: 500 })
      }
    },
  },
}
